// Listing-specific components
import { _ } from './utils'
import { productTracking, categoryViewTracking } from './tracking'
import LazyLoad from './modules/lazy-load'
import Listing from './modules/listing'
import Range from './modules/range'
import SearchModal from './modules/search-modal'

_('listing')
    .nodes()
    .forEach((el) => new Listing(el))
_('image', 'lazyload')
    .nodes()
    .forEach((el) => new LazyLoad(el))
_('category-view-tracking', 'element')
    .nodes()
    .forEach((el) => categoryViewTracking(el))

productTracking(_('product', 'element').nodes())

_('range')
    .nodes()
    .forEach((el) => new Range(el))

const siteSearchModal = document.querySelector('[data-element="site-search"].site-search')
if (siteSearchModal) {
    new SearchModal(siteSearchModal)
}
